import { FormikProps } from "formik";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { CapacityField } from "./CapacityField";
import { FormValues } from "./CustomReportView";
import { InputField } from "./InputFields";

interface LaptopTemplateProps {
    formikProps: FormikProps<FormValues>;
}

const LaptopTemplate: React.FC<LaptopTemplateProps> = React.memo(({ formikProps }) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = formikProps;

    const inputFields1 = useMemo(
        () => [
            {
                id: "assetTag",
                label: t("ErasureReport.customReport.templateSpecifications.assetTag"),
                dataPath: "user_data.fields.usercreatedreport.asset_tag",
            },
            {
                id: "comments",
                label: t("ErasureReport.customReport.templateSpecifications.comments"),
                dataPath: "user_data.fields.usercreatedreport.comments",
            },
        ],
        [values, t]
    );

    const inputFields2 = useMemo(
        () => [
            {
                id: "make",
                label: t("ErasureReport.customReport.templateSpecifications.make"),
                dataPath: "user_data.fields.usercreatedreport.make",
            },
        ],
        [values, t]
    );

    const inputFields3 = useMemo(
        () => [
            {
                id: "model",
                label: t("ErasureReport.customReport.templateSpecifications.model"),
                dataPath: "blancco_hardware_report.processors.processor.model",
            },
            {
                id: "processor",
                label: t("ErasureReport.customReport.templateSpecifications.processor"),
                dataPath: "user_data.fields.usercreatedreport.processor",
            },
            {
                id: "serialNumber",
                label: t("ErasureReport.customReport.templateSpecifications.serialNumber"),
                dataPath: "blancco_hardware_report.system.serial",
            },
            {
                id: "size",
                label: t("ErasureReport.customReport.templateSpecifications.size"),
                dataPath: "user_data.fields.usercreatedreport.size",
            },
            {
                id: "type",
                label: t("ErasureReport.customReport.templateSpecifications.type"),
                dataPath: "user_data.fields.usercreatedreport.type",
            },
        ],
        [values, t]
    );

    return (
        <>
            {inputFields1.map((field) => (
                <InputField
                    key={field.id}
                    id={field.id}
                    setFieldValue={setFieldValue}
                    label={field.label}
                    dataPath={field.dataPath}
                />
            ))}
            <CapacityField
                key="hddSize"
                id="hddSize"
                dataPath="blancco_hardware_report.disks.disk.capacity"
                setFieldValue={setFieldValue}
                label={t("ErasureReport.customReport.templateSpecifications.hddSize")}
            />
            {inputFields2.map((field) => (
                <InputField
                    key={field.id}
                    id={field.id}
                    setFieldValue={setFieldValue}
                    label={field.label}
                    dataPath={field.dataPath}
                />
            ))}
            <CapacityField
                key="memory"
                id="memory"
                dataPath="user_data.fields.usercreatedreport.memory"
                setFieldValue={setFieldValue}
                label={t("ErasureReport.customReport.templateSpecifications.memory")}
            />
            {inputFields3.map((field) => (
                <InputField
                    key={field.id}
                    id={field.id}
                    setFieldValue={setFieldValue}
                    label={field.label}
                    dataPath={field.dataPath}
                />
            ))}
        </>
    );
});

export default LaptopTemplate;
